export class BitmapFilterQuality {
    public static LOW: number = 1;
    public static MEDIUM: number = 2;
    public static HIGH: number = 3;
}
